export enum FiFileUploadState {
    //NotStarted = 0,
    InProgress = 1,
    Completed = 2,
    Failed = 3,
}
